import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { SportsDataService, SportsColumnsService } from '../../../services';
import { Sport, SportsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-sport-details',
  templateUrl: './sport-details.component.html',
  styleUrls: ['./sport-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class SportDetailsComponent implements OnInit, OnDestroy {

  public sport: Sport = {};
  public sports: Sport[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private sportsDataService: SportsDataService,
    private sportsColumnsService: SportsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Sport - Details');
        this.getSport(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.sport !== 'undefined') {
      this.sport = this.dynamicDialogConfig.data.sport;
    }
    this.columns = this.sportsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getSport(id: number): void {
    this.isLoading = true;
    this.sportsDataService.getSport(id).subscribe((response: Sport|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.sport = response;
      }
    });
  }

  list() {
    this.router.navigate(['/sports']);
  }

  add() {
    this.router.navigate(['/sports/add']);
  }

  edit() {
    this.router.navigate(['/sports/edit/' + this.sport.id]);
  }

}
@Component({
  selector: 'app-sport-details',
  templateUrl: './sport-details.component.html',
  styleUrls: ['./sport-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogSportDetailsComponent extends SportDetailsComponent {
}

